// extracted by mini-css-extract-plugin
module.exports = {"noData":"_a57f706","skeleton":"_88c47bf","dropdownSkeleton":"_1690bfd","tableSkeleton":"_4ac7bfd"};